import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function registerFormReducer(state = initialState.signInForm, action) {
    switch (action.type) {
        case types.SIGN_IN_USER_SUCCESS:
            return {
                ...state,
                isSignInSuccessful: action.signInProperties.isSignInSuccessful,
                signInMessages: action.signInProperties.signInMessages,
                isNewPasswordRequired: action.signInProperties.isNewPasswordRequired,
                cognitoUser: action.signInProperties.cognitoUser
            };
        case types.SIGN_IN_USER_ERROR:
            return {
                ...state,
                isSignInSuccessful: false,
                isNewPasswordRequired: false,
                signInMessages: action.signInMessages,
                cognitoUser: {}
            };
        case types.LAST_LOG_IN_UPDATE_SUCCESS:
            return {
                ...state,
                isUserLastLogInDataUpdated: action.lastLogInProperties.isUserLastLogInDataUpdated,
                userLastLogInDataErrorMessages: []
            };
        case types.LAST_LOG_IN_UPDATE_ERROR:
            return {
                ...state,
                isUserLastLogInDataUpdated: false,
                userLastLogInDataErrorMessages: action.errorMessages
            };
        case types.NEW_PASSWORD_SAVED_SUCCESS:
            return {
                ...state,
                isNewPasswordSavedSuccessful: true,
                newPasswordSavedMessages: action.newPasswordSavedMessages,
            };
        case types.NEW_PASSWORD_SAVED_ERROR:
            return {
                ...state,
                isNewPasswordSavedSuccessful: false,
                newPasswordSavedMessages: action.newPasswordSavedMessages,
            };
        case types.LOAD_NEW_PASSWORD_REQUIRED_FORM_DATA_SUCCESS:
            return {
                ...state,
                isNewPasswordRequiredFormDataLoadedSuccessful: true,
                newPasswordRequiredFormData: action.newPasswordRequiredFormData,
                loadPasswordRequiredFormDataMessages: []
            };
        case types.LOAD_NEW_PASSWORD_REQUIRED_FORM_DATA_ERROR:
            return {
                ...state,
                isNewPasswordRequiredFormDataLoadedSuccessful: false,
                loadPasswordRequiredFormDataMessages: action.loadPasswordRequiredFormDataMessages,
                newPasswordRequiredFormData: {}
            };
        case types.SIGN_OUT_USER_SUCCESS:
            return {
                ...state,
                isSignOutSuccessful: true,
                signOutMessages: action.signOutMessages
            };
        case types.SIGN_OUT_USER_ERROR:
            return {
                ...state,
                isSignOutSuccessful: false,
                signOutMessages: action.signOutMessages
            };
        case types.LOAD_SIGN_IN_FORM_DATA_SUCCESS:
            return {
                ...state,
                isFormLoadSuccessful: true,
                signInFormData: action.signInFormData
            };
        case types.LOAD_SIGN_IN_FORM_DATA_ERROR:
            return {
                ...state,
                isFormLoadSuccessful: false,
                signInFormData: {}
            };
        case types.LOAD_SIGN_IN_SUCCESS_FORM_DATA_SUCCESS:
            return {
                ...state,
                signInSuccessFormData: action.signInFormDataSuccess
            };
        case types.RESET_SIGN_IN_FORM_STATE:
            return {
                ...state,
                signInFormData: {},
                isFormLoadSuccessful: false,
                isSignInSuccessful: false,
                signInMessages: [],
                isSignOutSuccessful: false,
                signOutMessages: [],
                isNewPasswordRequired: false,
                cognitoUser: {},
                isNewPasswordRequiredFormDataLoadedSuccessful: false,
                loadPasswordRequiredFormDataMessages: [],
                newPasswordRequiredFormData: {},
                isNewPasswordSavedSuccessful: false,
                newPasswordSavedMessages: []
            };
        default:
            return state;
    }
}
